<template>
  <el-drawer
      :wrapperClosable="true"
      :title="title"
      :visible.sync="ShortPlayInfoFlag"
      size="50%"
      direction="rtl"
      :before-close="handleClose">

    <div class="demo-drawer__content">

      <el-form :model="addFrom" :rules="rules" ref="ruleForm" label-width="100px" class="mt35" v-loading="loading">
        <el-row :gutter="35">

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="小说名称" :label-width="formLabelWidth" prop="name">
              <el-input v-model="addFrom.name" placeholder="请输入小说名称" style="width: 90%;" :disabled="EditFlag"
                        autocomplete="off"></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="剧集总数" :label-width="formLabelWidth" prop="episode_total">
              <el-input v-model="addFrom.episode_total" type="number" placeholder="请输入剧集总数" style="width: 90%;" clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="上传封面" :label-width="formLabelWidth" prop="cover">
              <el-upload class="avatar-uploader" action :http-request="(file) => httpRequest(file)"
                         :disabled="this.addFrom.id?true:false"
                         :show-file-list="false" :on-success="handleAvatarSuccess"
                         :before-upload="beforeAvatarUpload">
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon" style="border:1px solid #ccc;"></i>
              </el-upload>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="发行年份" :label-width="formLabelWidth" prop="produce_year">
              <el-select v-model="addFrom.produce_year" placeholder="请选择版权方" clearable style="width: 90%;">
                <el-option v-for="dict in produceYearList" :key="dict.id" :label="dict.name"
                           :value="dict.name"/>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="连载状态" :label-width="formLabelWidth" prop="status">
              <el-radio-group v-model="addFrom.status">
                <el-radio :label="0">连载</el-radio>
                <el-radio :label="1">完结</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="制作机构" :label-width="formLabelWidth" prop="production_organisation">
              <el-input v-model="addFrom.production_organisation" placeholder="请输入制作机构" style="width: 90%;"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="推荐语(12字以内)" :label-width="formLabelWidth" prop="recommendation">
              <el-input v-model="addFrom.recommendation" placeholder="请输入推荐语" style="width: 90%;" clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="剧情描述(200字以内)" prop="description" :label-width="formLabelWidth">
              <el-input type="textarea" v-model="addFrom.description" placeholder="请输入剧情描述"
                        clearable style="width: 90%;"></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="类目标签(1-3个)" prop="b_tag_id" :label-width="formLabelWidth">
              <SelectChecked :options="tagOptions" :isRemoveAllTag="isRemoveAllTag" style="width: 90%;"
                             placeholder="请选择类目"
                             @selectedVal="selectedTags"/>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="平均单集时长(分钟)" prop="duration" :label-width="formLabelWidth">
              <el-input v-model="addFrom.duration" type="number" placeholder="请输入平均单集时长" style="width: 90%;" clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="导演" prop="director" :label-width="formLabelWidth">
              <el-input v-model="addFrom.director" placeholder="多个英文逗号隔开，例如：导演A,导演B,导演C" style="width: 90%;" clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="制作人" prop="producer" :label-width="formLabelWidth">
              <el-input v-model="addFrom.producer" placeholder="多个英文逗号隔开，例如：制作人A,制作人B,制作人C" style="width: 90%;" clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="演员" prop="actor" :label-width="formLabelWidth">
              <el-input v-model="addFrom.actor" placeholder="多个英文逗号隔开，例如：演员A,演员B,演员C" style="width: 90%;" clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="上传成本配置比例" :label-width="formLabelWidth" prop="cost_distribution_uri">
              <el-upload class="avatar-uploader" action :http-request="(file) => httpDistributionRequest(file)"
                         :show-file-list="false" :on-success="handleDistributionSuccess"
                         :before-upload="beforeAvatarUpload">
                <img v-if="cost_distribution_uri" :src="cost_distribution_uri" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon" style="border:1px solid #ccc;"></i>
              </el-upload>
            </el-form-item>
          </el-col>


        </el-row>
      </el-form>

    </div>
    <div class="demo-drawer__footer">
      <el-button @click="AddNone">取 消</el-button>
      <el-button type="primary" @click="addPush" :loading="loading">确 定</el-button>
    </div>
  </el-drawer>

</template>

<script>
import {WorksListAPI} from '@/api/Works/WorksList';
import {ByteBanceAPI} from '@/api/Works/ByteBance';
import {processErrors} from "@/utils/errorHandler";
import {administratorsAPI} from '@/api/account/administrators';
import SelectChecked from '@/components/Select/SelectChecked'

export default {
  props: ['ShortPlayInfoFlag', "editID"],
  components: {
    SelectChecked
  },
  data() {
    return {
      formLabelWidth: "160px",
      title: "新增",
      addFrom: {
        name: "",
        origin_name: "",
        book_name: "",
        cp_name: "",
        cover: "",
        source: 0,
        status: 1,
        visible: 0,
        episode_total: "",
        is_open_zrll: 0,
        charge_type: "1",
        episode_price: "",
        free_episode_total: "",
        description: "",
        category_id: "",
        level: "",
        tags: "",
        follows_count: "",
        cansee: 0,
        visible_channels: "",
        sequence: "",
        redirect: "",
        onself_time: "",
        id: "",
        is_iaa: 0,
        ad_priority: 1,
        produce_year: "",
        duration: 2,
        cost_distribution_uri:'',
      },
      rules: {
        cover: [
          {required: true, message: '请选择封面图片', trigger: 'blur'},
        ],
        cost_distribution_uri: [
          {required: true, message: '请上传成本配置比例情况', trigger: 'blur'},
        ],
        description: [
          {required: true, message: '请输入剧情描述', trigger: 'blur'},
        ],
        production_organisation: [
          {required: true, message: '请输入制作机构', trigger: 'blur'},
        ],
        duration: [
          {required: true, message: '请输入平均单集时长', trigger: 'blur'},
        ],
        recommendation: [
          {required: true, message: '请输入推荐语', trigger: 'blur'},
          {min: 1, max: 12,message: '12位以内推荐语', trigger: 'blur'},
        ],
        name: [
          {required: true, message: '请输入小说名称', trigger: 'blur'},
        ],
        episode_price: [
          {required: true, message: '请输入单集价格', trigger: 'blur'},
        ],
        director: [
          {required: true, message: '请输入导演', trigger: 'blur'},
        ],
        producer: [
          {required: true, message: '请输入制作人', trigger: 'blur'},
        ],
        actor: [
          {required: true, message: '请输入演员', trigger: 'blur'},
        ],
        episode_total: [
          {required: true, message: '请输入剧集总数', trigger: 'blur'},
        ],
        produce_year: [
          {required: true, message: '请选择发行年份', trigger: 'change'}
        ],
        status: [
          {required: true, message: '请选择连载状态', trigger: 'change'}
        ],
        b_tag_id: [
          {required: true, message: '请选择类目标签', trigger: 'blur'}
        ],

      },
      nameRole: "优化师",
      appidList: [],
      EditFlag: false,
      imageUrl: "",
      loading: false,
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      copyrightList: [],
      produceYearList: [],
      isRemoveAllTag: 0,
      tagOptions: [],
      cost_distribution_uri:'',
    };
  },
  created() {
    this.getclassifyList()
    this.getCopyRightList()
    this.setYearList()
    this.getTagOptions()
  },
  methods: {

    /**
     * 设置年份列表
     */
    setYearList() {
      const currentYear = new Date().getFullYear(); // 获取当前年份
      this.produceYearList = []; // 清空数组
      for (let i = 0; i < 5; i++) {
        const year = currentYear - i;
        this.produceYearList.push({id: i + 1, name: year}); // 添加对象到数组
      }
    },

    selectedTags(value) {
      this.addFrom.b_tag_id = value.join(',');
    },

    getTagOptions() {
      let api = ByteBanceAPI()
      api.getTags().then((res) => {
        let data = res.data;
        this.tagOptions = data.map(item => ({
          value: item.tag_id,
          label: item.tag_name,
          check: false
        }));

      });
    },

    handleAvatarSuccess(res, file) {
      this.addFrom.cover = URL.createObjectURL(file.raw);
    },

    handleDistributionSuccess(res, file) {
      this.addFrom.cost_distribution_uri = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
    },
    httpRequest(file) {
      let api = WorksListAPI()
      this.imageUrl = new FormData();
      this.imageUrl.append("file", file.file);

      api.fileUpload(this.imageUrl).then((res) => {
        this.imageUrl = res.data;
        this.addFrom.cover = res.data;

      });
    },

    httpDistributionRequest(file) {
      let api = ByteBanceAPI()
      this.cost_distribution_uri = new FormData();
      this.cost_distribution_uri.append("file", file.file);

      api.fileDistributionUpload(this.cost_distribution_uri).then((res) => {
        this.cost_distribution_uri = res.data;
        this.addFrom.cost_distribution_uri = res.data;
      });
    },
    /**
     * 获取版权方列表
     */
    getCopyRightList() {
      let api = administratorsAPI()
      let adminParams = {
        pageNo: 1,
        pageSize: 10000,
        group: 11
      }
      api.administratorsList(adminParams).then(res => {
        if (res.code == 0) {
          this.copyrightList = res.data.data
        } else {
          processErrors(res);
        }
      })
    },
    getclassifyList() {
      let api = WorksListAPI()
      api.classifyList(this.page).then(res => {
        if (res.code == 0) {
          this.appidList = res.data
        } else {
          processErrors(res);
        }
      })
    },
    handleClose(done) {
      this.$emit('NoneDlog')
      this.$refs['ruleForm'].resetFields();
    },
    AddNone() {
      this.addFrom = {
        name: "",
        origin_name: "",

        cp_name: "",
        cover: "",
        source: "",
        status: "",
        visible: "",
        episode_total: "",
        is_open_zrll: "",
        charge_type: "1",
        episode_price: "",
        free_episode_total: "",
        description: "",
        category_id: "",
        level: "",
        tags: "",
        follows_count: "",
        cansee: "0",
        visible_channels: "",
        sequence: "",
        redirect: "",
        copyright_id: "",
        onself_time: "",
        id: "",
        is_iaa: 0,
        ad_priority: 1
      }
      this.$refs['ruleForm'].resetFields();
      this.$emit('NoneDlog');
    },

    addPush() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.loading = true;
          let api = WorksListAPI()
          if (this.addFrom.id == "") {
            api.WorksAdded(this.addFrom).then(res => {
              if (res.code == 0) {
                this.$message({
                  message: '创建成功',
                  type: 'success'
                });
                this.$emit('AddOk');
              } else {
                processErrors(res);
                this.$emit('AddOk');
              }

            })
          } else {
            api.WorksAdded(this.addFrom).then(res => {
              if (res.code == 0) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.$emit('AddOk');
              } else {
                processErrors(res);
                this.$emit('AddOk');
              }

            })
          }
          this.loading = false;
        } else {

          return false;
        }
      });

    }
  },

  mounted() {
    if (this.editID != "") {
      this.loading = true;
      let api = WorksListAPI()
      api.detailsList(this.editID).then(res => {
        if (res.code == 0) {
          this.imageUrl = res.data.full_cover
          this.title = "编辑"
          this.addFrom = res.data
          this.addFrom.tags = res.data.tags.join(',')
          // this.addFrom.produce_year = new Date().getFullYear()

          this.addFrom.is_iaa = res.data.is_iaa == null ? 0 : res.data.is_iaa
          this.addFrom.ad_priority = res.data.ad_priority == null ? 1 : res.data.ad_priority

          this.loading = false;
        } else {
          processErrors(res);
        }
      })
    }

  },
}
</script>
<style lang='scss' scoped>
.Box {
  & ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 0 !important;
    }
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  //flex: 1; /* 让按钮平分容器宽度 */
  width: 320px; /* 设置按钮宽度为120px */
}

.demo-drawer__content {
  height: calc(100% - 80px); /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto; /* 添加垂直滚动条 */
  margin-top: 20px;
  overflow-x: hidden;
}

::v-deep .el-drawer__close-btn {
  font-size: 30px;
  font-weight: bold;
}
</style>